/**
 * RICH-1900. Report showing the fees a merchant actually collected, per month.
 *
 * Note the lowercase dataIndex values: Postgres downcases column aliases, so
 * `labelFeeTotal` in the query arrives as `labelfeetotal`. The existing
 * label/Costs.js report has the same quirk.
 *
 * @component
 */

import React from "react";
import Report from "../Report";

const columns = [
  {
    title: "Month",
    dataIndex: "month",
  },
  {
    title: "Label Fees",
    dataIndex: "labelfeetotal",
  },
  {
    title: "Restocking Fees",
    dataIndex: "restockingfeetotal",
  },
  {
    title: "Custom Fees",
    dataIndex: "customfeetotal",
  },
  {
    title: "Total Fees Collected",
    dataIndex: "totalfees",
  },
  {
    title: "Refunds",
    dataIndex: "refundcount",
  },
];

const exportHeaders = [
  {
    label: "Month",
    value: "month",
  },
  {
    label: "Label Fees",
    value: "labelfeetotal",
  },
  {
    label: "Restocking Fees",
    value: "restockingfeetotal",
  },
  {
    label: "Custom Fees",
    value: "customfeetotal",
  },
  {
    label: "Total Fees Collected",
    value: "totalfees",
  },
  {
    label: "Refunds",
    value: "refundcount",
  },
];

class FeesCollected extends React.Component {
  render() {
    return (
      <Report
        url="/api/reports/fees/collected"
        title="Fees Collected"
        tooltip="Label, restocking and custom fees withheld from refunds you have issued, grouped by month. Totals come from the amount actually withheld, so the three columns always add up."
        columns={columns}
        reportName="fees-collected"
        exportHeaders={exportHeaders}
        startDate={this.props.startDate}
        endDate={this.props.endDate}
        updateDate={this.props.updateDate}
      />
    );
  }
}

export default FeesCollected;
